import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { GlassCard } from "@/components/GlassCard";
import { StatusBadge } from "@/components/StatusBadge";
import { Inbox } from "lucide-react";

export default function Approvals() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/workflows/mine");
        setRows(data);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="space-y-6" data-testid="approvals-page">
      <header>
        <h1 className="font-display text-3xl md:text-4xl font-semibold text-white">Approvals inbox</h1>
        <p className="text-[#9AA4B2] text-sm mt-1">SOPs awaiting your review and sign-off.</p>
      </header>

      {loading ? (
        <GlassCard className="p-10 animate-pulse-glow h-32" />
      ) : rows.length === 0 ? (
        <GlassCard className="p-16 text-center" data-testid="approvals-empty">
          <div className="mx-auto w-14 h-14 rounded-2xl glass flex items-center justify-center text-emerald-300 mb-4">
            <Inbox size={22} />
          </div>
          <div className="text-white font-display text-lg">Inbox zero.</div>
          <div className="text-[#9AA4B2] text-sm mt-1">Nothing needs your review right now.</div>
        </GlassCard>
      ) : (
        <div className="space-y-3">
          {rows.map((w) => (
            <GlassCard
              key={w.id}
              hoverable
              className="p-5 cursor-pointer"
              onClick={() => navigate(`/sops/${w.sop_id}`)}
              data-testid={`approval-row-${w.id}`}
            >
              <div className="flex items-center justify-between gap-3">
                <div className="min-w-0">
                  <div className="font-display text-lg text-white truncate">{w.sop_title}</div>
                  <div className="text-xs text-[#9AA4B2] mt-1">
                    {w.sop_department || "—"} · submitted {new Date(w.created_at).toLocaleDateString()}
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <StatusBadge status={w.status} />
                  <StatusBadge status={w.sop_status} />
                </div>
              </div>
            </GlassCard>
          ))}
        </div>
      )}
    </div>
  );
}
